module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Gc-Ha-Ia.9fd83b85.png";